/**
 * Curated HTTPS streams for /audio-player (third-party; availability may change).
 * SomaFM stations are free to listen — https://somafm.com
 */
export const WEB_STREAM_GENRES = [
  {
    id: 'ambient',
    label: 'Ambient & chill',
    streams: [
      {
        id: 'soma-groove-salad',
        title: 'Groove Salad',
        subtitle: 'Downtempo ambient',
        url: 'https://ice1.somafm.com/groovesalad-128-mp3',
      },
      {
        id: 'soma-deep-space',
        title: 'Deep Space One',
        subtitle: 'Deep ambient space',
        url: 'https://ice1.somafm.com/deepspaceone-128-mp3',
      },
      {
        id: 'soma-drone-zone',
        title: 'Drone Zone',
        subtitle: 'Atmospheric drones',
        url: 'https://ice1.somafm.com/dronezone-128-mp3',
      },
      {
        id: 'soma-fluid',
        title: 'Fluid',
        subtitle: 'Instrumental hip-hop',
        url: 'https://ice1.somafm.com/fluid-128-mp3',
      },
    ],
  },
  {
    id: 'electronic',
    label: 'Electronic',
    streams: [
      {
        id: 'soma-beat-blender',
        title: 'Beat Blender',
        subtitle: 'House & downtempo',
        url: 'https://ice1.somafm.com/beatblender-128-mp3',
      },
      {
        id: 'soma-secret-agent',
        title: 'Secret Agent',
        subtitle: 'Spy & surf lounge',
        url: 'https://ice1.somafm.com/secretagent-128-mp3',
      },
      {
        id: 'soma-cliqhop',
        title: 'Cliqhop IDM',
        subtitle: 'IDM & glitch',
        url: 'https://ice1.somafm.com/cliqhop-128-mp3',
      },
      {
        id: 'soma-poptron',
        title: 'PopTron',
        subtitle: 'Electropop & synth',
        url: 'https://ice1.somafm.com/poptron-128-mp3',
      },
    ],
  },
  {
    id: 'rock',
    label: 'Rock & alternative',
    streams: [
      {
        id: 'gold-soft-rock',
        title: 'Soft Rock',
        subtitle: 'Easy rock mix',
        url: 'https://gold.streamguys1.com/softrock.mp3',
      },
      {
        id: 'soma-indie-pop',
        title: 'Indie Pop Rocks',
        subtitle: 'Indie & alternative',
        url: 'https://ice1.somafm.com/indiepop-128-mp3',
      },
      {
        id: 'soma-metal',
        title: 'Metal Detector',
        subtitle: 'Heavy & metal',
        url: 'https://ice1.somafm.com/metal-128-mp3',
      },
      {
        id: 'soma-u80s',
        title: 'Underground 80s',
        subtitle: '80s underground',
        url: 'https://ice1.somafm.com/u80s-128-mp3',
      },
    ],
  },
  {
    id: 'jazz',
    label: 'Jazz & soul',
    streams: [
      {
        id: 'soma-lush',
        title: 'Lush',
        subtitle: 'Vocal jazz',
        url: 'https://ice1.somafm.com/lush-128-mp3',
      },
      {
        id: 'soma-sonic-universe',
        title: 'Sonic Universe',
        subtitle: 'Jazz fusion',
        url: 'https://ice1.somafm.com/sonicuniverse-128-mp3',
      },
      {
        id: 'soma-7soul',
        title: '7 Inch Soul',
        subtitle: 'Deep funk & soul',
        url: 'https://ice1.somafm.com/7soul-128-mp3',
      },
      {
        id: 'soma-bossa',
        title: 'Bossa Beyond',
        subtitle: 'Bossa & Brazilian',
        url: 'https://ice1.somafm.com/bossabeyond-128-mp3',
      },
    ],
  },
  {
    id: 'folk',
    label: 'Folk & country',
    streams: [
      {
        id: 'soma-thistle',
        title: 'ThistleRadio',
        subtitle: 'Celtic & folk',
        url: 'https://ice1.somafm.com/thistle-128-mp3',
      },
      {
        id: 'soma-boot-liquor',
        title: 'Boot Liquor',
        subtitle: 'Americana & country',
        url: 'https://ice1.somafm.com/bootliquor-128-mp3',
      },
      {
        id: 'soma-covers',
        title: 'Covers',
        subtitle: 'Cover songs',
        url: 'https://ice1.somafm.com/covers-128-mp3',
      },
    ],
  },
  {
    id: 'classical',
    label: 'Classical & acoustic',
    streams: [
      {
        id: 'soma-illinois',
        title: 'Illinois Street Lounge',
        subtitle: 'Classical crossover',
        url: 'https://ice1.somafm.com/illstreet-128-mp3',
      },
      {
        id: 'soma-space-station',
        title: 'Space Station',
        subtitle: 'Space-themed eclectic',
        url: 'https://ice1.somafm.com/spacestation-128-mp3',
      },
      {
        id: 'soma-def-con',
        title: 'DEF CON Radio',
        subtitle: 'Hacker conference vibe',
        url: 'https://ice1.somafm.com/defcon-128-mp3',
      },
    ],
  },
];

export function findStreamByUrl(url) {
  const needle = String(url || '').trim();
  if (!needle) return null;
  for (const genre of WEB_STREAM_GENRES) {
    for (const stream of genre.streams) {
      if (stream.url === needle) return { ...stream, genreLabel: genre.label, genreId: genre.id };
    }
  }
  return null;
}
